/** @format */

const localeTextTR = {
  // for filter panel
  page: "Sayfa",
  more: "Devamı",
  to: "To",
  of: "Of",
  next: "İleri",
  last: "Son",
  first: "İlk",
  previous: "Sonraki",
  loadingOoo: "Yükleniyor...",

  // for set filter
  selectAll: "Tümünü seç",
  searchOoo: "Ara...",
  blank: "Boş",
  notBlank: "Boş değilse",

  // for number filter and text filter
  filterOoo: "Filtrele...",
  applyFilter: "choose...",
  equals: "Eşittir",
  notEqual: "Eşit değilse",

  lessThan: "Küçüktür",
  greaterThan: "Büyüktür",
  lessThanOrEqual: "Küçük eşit",
  greaterThanOrEqual: "Büyük eşit",
  inRange: "Aralık",

  // for text filter
  contains: "İçeriyorsa",
  notContains: "İçermiyorsa",
  startsWith: "Başlıyorsa",
  endsWith: "Bitiyorsa",

  // the header of the default group column
  group: "Grup",

  // tool panel
  columns: "Sütunlar",
  filters: "Filtreler",
  rowGroupColumns: "Pivot Sütun",
  rowGroupColumnsEmptyMessage: " sütunları gruba sürükle",
  valueColumns: "Sütun Değeri",
  pivotMode: "Pivot-Modu",
  groups: "Gruplar",
  values: "Değerler",
  pivots: "Pivotlar",
  valueColumnsEmptyMessage: " toplamak için sütunları sürükleyin",
  pivotColumnsEmptyMessage: " pivot için buraya sürükleyin",
  toolPanelButton: "Araç çubuğu",

  // other
  noRowsToShow: " Daha önce veri eklenmemiş.",

  // enterprise menu
  pinColumn: "Stünu sabitle",
  valueAggregation: "Değer",
  autosizeThiscolumn: "Sığdır",
  autosizeAllColumns: "Sütunları tomatik boyutlandır",
  groupBy: "Grupla",
  ungroupBy: "Gruplama",
  resetColumns: "Sütunları sıfırla",
  expandAll: "Hepsini aç",
  collapseAll: "Hepsini kapat",
  toolPanel: "Araç paneli",
  export: "İndir",
  csvExport: "CSV olarak indir",
  excelExport: "Excel olarak indir",

  // enterprise menu pinning
  pinLeft: "Sola yasla <<",
  pinRight: "Sağa yasla >>",
  noPin: "Yaslama <>",

  // enterprise menu aggregation and status panel
  sum: "Sum",
  min: "En az",
  max: "En çok",
  first: "İlk",
  last: "Son",
  none: "Yok",
  count: "Say",
  verage: "Ortalama",
  pinColumn: "Sütunu Sabitle",
  resetColumns: "Sütunları Sıfırla",
  // standard menu
  sortAscending: "Artan Sırala",
  sortDescending: "Azalan Sırala",
  autosizeThisColumn: "Bu Sütunu Otomatik Boyutlandır",
  autosizeAllColumns: "Tüm Sütunları Otomatik Boyutlandır",
  chooseColumns:"Sütunları Seç",
  
  cut: "Kes",
  copy: "Kopyala",
  copyWithHeaders: "Başlığı kopyala",
  copyWithGroupHeaders: "Grup Başlığı ile kopyala",
  ctrlC: "ctrl C",
  paste: "Yapıştır",
  ctrlV: "ctrl C",
};

export default localeTextTR;
